module.exports = __webpack_public_path__ + "static/middle-dd8df178144c7edb3ab3044114b149e3.png";